import { apiConfig } from "./config";

/**
 * Timeout-aware fetch used by the generated SDK client. Uploads (multipart
 * bodies) get the extended budget. Composes with any caller-provided signal
 * (e.g. TanStack Query cancellation).
 */
export function fetchWithBudget(timeoutMs?: number): typeof fetch {
  return (input, init) => {
    const request = input instanceof Request ? input : new Request(input, init);
    // Vitest: undici's fetch rejects jsdom's composed AbortSignal (instanceof
    // mismatch) and MSW answers synchronously — skip the client-side timeout.
    if (typeof process !== "undefined" && process.env?.VITEST) {
      return fetch(request);
    }
    const isUpload = request.headers.get("Content-Type")?.includes("multipart/form-data") ?? false;
    const budget = timeoutMs ?? (isUpload ? apiConfig.uploadTimeout : apiConfig.timeout);
    return fetch(request, {
      signal: AbortSignal.any([request.signal, AbortSignal.timeout(budget)]),
    });
  };
}

export const fetchWithTimeout: typeof fetch = fetchWithBudget();
